import { canv } from "@/canv/global";
import { logException } from "@/canv/utils";
import { Group } from "@/group";

export function loadGroupsTree(canvStr: string) {
    let parsedCanv: { children: unknown[] };

    try {
        parsedCanv = JSON.parse(canvStr);
    } catch (e) {
        logException(new Error("Board parsing fail"));
        throw 1;
    }

    const groups: Group[] = [];

    for (let i = 0; i < parsedCanv.children.length; i++) {
        const newG = new Group();

        groups.push(newG);
        newG.loadGroup(parsedCanv.children[i] as Group);
    }

    return groups;
}

export function getViewport() {
    return {
        viewportStartX: -canv.m[4] / canv.m[0],
        viewportStartY: -canv.m[5] / canv.m[3],
        viewportWidth: canv.canvas.width / canv.m[0],
        viewportHeight: canv.canvas.height / canv.m[3],
    };
}

export function sortByIndexByParent(container: Group[]) {
    const compare = (a: Group, b: Group) => {
        if (a.indexByParent < b.indexByParent) {
            return -1;
        }
        if (a.indexByParent > b.indexByParent) {
            return 1;
        }
        return 0;
    };

    container.sort(compare);
}

/**
 * Сортирует группы по позиции на доске: сверху вниз, слева направо
 */
export function sortGroupsByPosition(groups: Group[]) {
    groups.sort((a, b) => {
        // Сначала сравниваем по Y (сверху вниз)
        const yDiff = a.startY - b.startY;
        if (yDiff !== 0) {
            return yDiff;
        }
        // Если Y одинаковый, сравниваем по X (слева направо)
        return a.startX - b.startX;
    });
}

export const getFirstSelected = () => {
    if (canv.canvasController.selected.length !== 1) {
        logException(new Error("[board] [error] : getFirstSelected - selected size is not 1"));
    }

    return canv.canvasController.selected[0];
};

export function toScreenCoords(startX: number, startY: number) {
    const viewport = getViewport();
    const zoom = document.body.clientWidth / viewport.viewportWidth;

    const x = (viewport.viewportStartX - startX) * zoom * -1;
    const y = (viewport.viewportStartY - startY) * zoom * -1;

    return { x, y };
}
